import { useAuth0 } from "@auth0/auth0-react";
import { useMutation, useQueryClient } from "react-query";
import { Order } from "../../types/api/Order";
import { Post } from "../utils/api";

interface AddShipmentMethodToOrderBody {
  rate_id: string;
}

export default (orgId: string, buyerOrgId: string, orderId: string) => {
  const { getAccessTokenSilently } = useAuth0();
  const queryClient = useQueryClient();
  return useMutation<Order, null, AddShipmentMethodToOrderBody>(
    `shipping_rate_order_${orderId}`,
    async (body: AddShipmentMethodToOrderBody) =>
      Post(
        `/api/shipping/order/${orderId}/rate`,
        await getAccessTokenSilently(),
        { rate_id: body.rate_id }
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(`current_cart_${orgId}_${buyerOrgId}`);
        queryClient.invalidateQueries(`credit_cards_${buyerOrgId}`);
      },
    }
  );
};
